import React, { Suspense } from 'react'
import PublicPageLoader from '../../../component/Elements/publicPageLoader'
import { lazyWithRetry } from '../../../helper/lazyWithRetry'

const PasswordLess = lazyWithRetry(() => import(/* webpackChunkName: "password-less" */'../../../component/Login/PasswordLess'))

const PasswordLessPage = React.memo(() => {
	return (
		<Suspense fallback={<PublicPageLoader />}>
			<PasswordLess />
		</Suspense>
	)
})

PasswordLessPage.displayName = 'PasswordLessPage'
export default PasswordLessPage
